var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skin-sensitivity-template',{attrs:{"skin-reacts-to-products":_vm.skinReactsToProducts,"safe-cleansers":_vm.safeCleansers,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }